
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialSection from './TestimonialKeyword';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';function Punetomahabaleshwarertiga() {



    const cardData =
    {
        keyword: ' Pune to Mahabaleshwar Ertiga On Rent',
        heading: 'Prince Cabs: Pune to Mahabaleshwar Ertiga On Rent',
        headingDescription: 'Prince Cabs provides reliable Pune to Mahabaleshwar Ertiga on Rent, ideal for family vacations, weekend trips, corporate outings, and sightseeing tours. Our spacious and well-maintained Ertiga vehicles ensure a safe, comfortable, and budget-friendly ride through the scenic ghats to Mahabaleshwar. With professional chauffeurs, flexible booking options, and on-time service, we make your travel completely hassle-free. Enjoy convenience, affordability, and comfort with Prince Cabs’ trusted Ertiga rental service from Pune to Mahabaleshwar.',

        top: 'Top Places to Visit in Mahabaleshwar with Prince Cabs',

"topPlaces": [
  {
    "title": "Venna Lake",
    "description": "Venna Lake is the most popular attraction in Mahabaleshwar, surrounded by lush greenery and hills. Visitors enjoy boat rides, horse riding, and lakeside snacks. The lakefront is especially lively during evenings with families and couples. In monsoon and winter, mist adds a magical charm. Street food stalls selling corn and strawberries are a delight. Venna Lake is the perfect family-friendly spot."
  },
  {
    "title": "Mapro Garden",
    "description": "Mapro Garden is famous for its strawberry produce, jams, and juices. The garden features a café serving strawberry cream, pizzas, and mocktails. It hosts the annual Strawberry Festival during summer, attracting thousands of tourists. Visitors can shop for chocolates, syrups, and organic products. Its green lawns and open-air seating create a relaxing vibe. Mapro Garden is Mahabaleshwar’s foodie paradise."
  },
  {
    "title": "Arthur’s Seat Point",
    "description": "Arthur’s Seat, often called the Queen of Points, offers breathtaking views of the deep Savitri River Valley and the Konkan region. The spot is known for its optical illusion where objects thrown down appear to float. It is a favorite for photographers and nature lovers. The viewpoint is especially stunning at sunset. Trekking to the point adds adventure to the visit. Arthur’s Seat is Mahabaleshwar’s most scenic viewpoint."
  },
  {
    "title": "Elephant’s Head Point",
    "description": "Elephant’s Head Point is a unique rock formation resembling an elephant’s trunk. Located near Kate’s Point, it offers panoramic views of the Sahyadri ranges and valleys. The location is calm and ideal for photography. Clouds often hover low here during monsoon, creating dreamy scenery. Tourists love combining it with nearby viewpoints. Elephant’s Head Point is Mahabaleshwar’s natural wonder."
  },
  {
    "title": "Pratapgad Fort",
    "description": "Pratapgad Fort, built by Chhatrapati Shivaji Maharaj in 1656, is a historic landmark near Mahabaleshwar. The fort is famous for the battle between Shivaji Maharaj and Afzal Khan. Visitors explore bastions, temples, and panoramic valley views. The Bhavani Mata Temple adds spiritual importance. Trekking to the fort is popular among adventure seekers. Pratapgad is Mahabaleshwar’s pride in Maratha history."
  },
  {
    "title": "Lingmala Waterfall",
    "description": "Lingmala Waterfall is one of the most beautiful waterfalls in Mahabaleshwar. The falls cascade from a height of 600 feet into the valley below. The viewpoint offers breathtaking monsoon scenery. Visitors enjoy trekking trails leading to the spot. The waterfall looks spectacular during the rainy season with mist all around. Lingmala is Mahabaleshwar’s refreshing natural retreat."
  },
  {
    "title": "Wilson Point (Sunrise Point)",
    "description": "Wilson Point, also called Sunrise Point, is the highest point in Mahabaleshwar at 4,710 feet. It offers a 360-degree view of the surrounding valleys and hills. Tourists flock here early morning to witness the sunrise. The site also provides beautiful sunset views. It is an excellent spot for photography. Wilson Point is the best vantage point in Mahabaleshwar."
  },
  {
    "title": "Kate’s Point and Needle Hole Point",
    "description": "Kate’s Point, named after the daughter of Sir John Malcolm, offers stunning valley views. Nearby Needle Hole Point has a natural rock formation with a hole resembling a needle. Both spots are great for photography and sightseeing. Monsoon adds misty beauty to the views. They are among the most-visited tourist points in Mahabaleshwar. Kate’s Point is a blend of history and natural charm."
  },
  {
    "title": "Mahabaleshwar Temple",
    "description": "The Mahabaleshwar Temple, dedicated to Lord Shiva, is an ancient pilgrimage site. Built in the 16th century, it features a swayambhu linga made of black stone. The temple is highly revered and visited by devotees year-round. Its Hemadpanti-style architecture adds to its spiritual charm. Surrounded by peaceful landscapes, it provides a calm retreat. Mahabaleshwar Temple is a sacred gem of the hill station."
  },
  {
    "title": "Panch Ganga Temple",
    "description": "The Panch Ganga Temple marks the origin of five holy rivers: Krishna, Venna, Koyna, Savitri, and Gayatri. Built in the 13th century by Raja Singhandeo, it holds immense religious importance. Devotees believe bathing in its waters purifies the soul. The temple’s architecture is simple yet spiritually powerful. Surrounded by hills, it is a serene spot for pilgrims. Panch Ganga Temple is Mahabaleshwar’s spiritual landmark."
  },
  {
    "title": "Tapola (Mini Kashmir)",
    "description": "Tapola, located 25 km from Mahabaleshwar, is known as ‘Mini Kashmir.’ It is famous for its backwaters of the Koyna Dam. Tourists enjoy boating, kayaking, and camping by the lakeside. The lush greenery and mountains create a scenic escape. Adventure enthusiasts also trek in nearby forests. Tapola is Mahabaleshwar’s offbeat and peaceful getaway."
  },
  {
    "title": "Connaught Peak",
    "description": "Connaught Peak, formerly Mount Olympia, is the second-highest peak in Mahabaleshwar. It offers panoramic views of Krishna Valley, Venna Lake, and Panchgani. The viewpoint is popular among trekkers and nature enthusiasts. Sunsets here are mesmerizing with golden skies. It is less crowded, making it peaceful for visitors. Connaught Peak is Mahabaleshwar’s hidden gem."
  },
  {
    "title": "Table Land, Panchgani",
    "description": "Table Land in nearby Panchgani is Asia’s second-longest mountain plateau. It stretches across 6 km and is famous for horse riding, paragliding, and film shoots. The plateau offers stunning valley views and sunsets. During monsoon, it becomes a lush green carpet. Tourists often combine it with a Mahabaleshwar trip. Table Land is a natural wonder of the region."
  },
  {
    "title": "Elephant Point Strawberry Farms",
    "description": "Mahabaleshwar is famous for its strawberry farms, producing 85% of India’s strawberries. Visitors enjoy farm tours and pluck fresh strawberries. Strawberry cream and milkshakes are local delicacies. The farms are most vibrant during winter and early summer. Tourists shop for jams, jellies, and syrups. Strawberry farms are Mahabaleshwar’s sweet delight."
  },
  {
    "title": "Arthur’s Seat Valley Trek",
    "description": "For adventure seekers, trekking through Arthur’s Seat Valley is an unforgettable experience. The trail passes through forests, cliffs, and river views. It offers close encounters with Sahyadri’s rugged beauty. The trek is especially popular during monsoon with mist and waterfalls. Photography enthusiasts love the panoramic landscapes. It is Mahabaleshwar’s adventurous escape."
  }
],

"services": [
  {
    "name": "Pune to Mahabaleshwar Ertiga Booking",
    "description": "Book a reliable Ertiga cab from Pune to Mahabaleshwar for a comfortable and scenic hill station ride. This 7-seater is perfect for families, friends, or small groups looking to escape the city. Enjoy flexible pickup options, experienced drivers, and well-maintained vehicles that ensure a smooth and hassle-free journey to the heart of the Sahyadris."
  },
  {
    "name": "Ertiga 7 Seater Pune to Mahabaleshwar",
    "description": "Hire a spacious 7-seater Ertiga for your Pune to Mahabaleshwar trip and travel in comfort. With roomy interiors, ample luggage space, and powerful AC, this cab is ideal for group travel. Whether it’s a weekend getaway or a vacation with family, the Ertiga delivers the perfect blend of space and efficiency for hill station drives."
  },
  {
    "name": "Ertiga for Family Trip to Mahabaleshwar",
    "description": "Make your family trip from Pune to Mahabaleshwar memorable with our comfortable and affordable Ertiga cabs. This vehicle offers safety, space, and air-conditioned comfort, making it a top choice for families with children or elderly passengers. Our professional drivers ensure a safe and enjoyable travel experience across the scenic ghats."
  },
  {
    "name": "Ertiga One Way Cab Pune to Mahabaleshwar",
    "description": "Book a one-way Ertiga cab from Pune to Mahabaleshwar at an affordable price. Perfect for travelers who plan to stay in Mahabaleshwar or have a return booked later. Enjoy clean vehicles, polite drivers, and smooth door-to-door service with no hidden return charges."
  },
  {
    "name": "Pune to Mahabaleshwar Round Trip Ertiga",
    "description": "Planning a same-day or overnight trip? Our round trip Ertiga service from Pune to Mahabaleshwar ensures you enjoy both legs of the journey comfortably. Flexible return options, trained drivers, and clean vehicles make this an ideal choice for weekend retreats, sightseeing, or short vacations."
  },
  {
    "name": "Pune to Mahabaleshwar Affordable Ertiga",
    "description": "Travel affordably from Pune to Mahabaleshwar with our budget-friendly Ertiga cab options. Ideal for cost-conscious families and groups, these cabs offer AC, comfort, and reliability without high fares. Enjoy mountain drives and cool weather without worrying about travel expenses."
  },
  {
    "name": "Pune to Mahabaleshwar AC Ertiga Cab",
    "description": "Stay cool and relaxed throughout your Pune to Mahabaleshwar journey in our air-conditioned Ertiga cabs. With powerful cooling, comfortable seating, and plenty of space, these cabs are perfect for beating the heat and enjoying the lush landscapes en route."
  },
  {
    "name": "Ertiga Outstation Cab Pune",
    "description": "Hire an Ertiga outstation cab from Pune for long-distance trips like Mahabaleshwar, Lonavala, Goa, or Shirdi. Spacious seating, professional drivers, and well-maintained cars make this a great pick for group travel. Choose from one-way or round trip options as per your convenience."
  },
  {
    "name": "Pune to Mahabaleshwar SUV Ertiga",
    "description": "Book an SUV-style Ertiga from Pune to Mahabaleshwar for comfort, power, and road stability. The Ertiga’s elevated ground clearance and smooth handling make it perfect for hilly terrain and ghat roads. A reliable option for safe family or group travel to the hills."
  },
  {
    "name": "Ertiga Tour Package Pune to Mahabaleshwar",
    "description": "Choose from our Pune to Mahabaleshwar Ertiga tour packages including cab service, sightseeing, and return travel. Designed for families and groups, these packages offer flexibility in duration, pickup time, and destinations covered. A complete, affordable solution for your hill station vacation."
  },
  {
    "name": "Comfortable Ertiga Cab Pune",
    "description": "Enjoy a relaxing ride in our comfortable Ertiga cabs from Pune, suitable for both local and outstation travel like Mahabaleshwar. With reclining seats, air conditioning, and professional drivers, these cabs provide a high level of comfort on long journeys."
  },
  {
    "name": "Pune to Mahabaleshwar Cab with Driver",
    "description": "Book a fully serviced Ertiga cab with an experienced driver from Pune to Mahabaleshwar. Our drivers are familiar with the route, local attractions, and hill driving, ensuring a safe, timely, and informative travel experience for tourists and regular visitors alike."
  },
  {
    "name": "Ertiga Crysta Pune to Mahabaleshwar",
    "description": "Upgrade your journey with a premium Ertiga Crysta cab from Pune to Mahabaleshwar. With plush interiors, enhanced comfort, and reliable performance, this option is ideal for luxury travelers or families seeking an elevated travel experience to the hills."
  },
  {
    "name": "Wedding Trip Pune to Mahabaleshwar Ertiga",
    "description": "Heading to Mahabaleshwar for a wedding? Our Ertiga cabs offer elegant travel for family members, friends, or the bridal party. Spacious, neat, and perfect for group transfers, the cab ensures everyone arrives in comfort and on time for the celebrations."
  },
  {
    "name": "Group Travel Cab Ertiga Pune",
    "description": "Planning a group trip from Pune? Book an Ertiga cab for a comfortable ride with your group to destinations like Mahabaleshwar. Enjoy quality time with your travel companions without the hassle of coordinating multiple vehicles or dealing with public transport."
  }
],
"tableData": [
  ["Pune to Mahabaleshwar Ertiga Booking", "Ertiga 7 Seater Pune to Mahabaleshwar"],
  ["Ertiga for Family Trip to Mahabaleshwar", "Ertiga One Way Cab Pune to Mahabaleshwar"],
  ["Pune to Mahabaleshwar Round Trip Ertiga", "Pune to Mahabaleshwar Affordable Ertiga"],
  ["Pune to Mahabaleshwar AC Ertiga Cab", "Ertiga Outstation Cab Pune"],
  ["Pune to Mahabaleshwar SUV Ertiga", "Ertiga Tour Package Pune to Mahabaleshwar"],
  ["Comfortable Ertiga Cab Pune", "Pune to Mahabaleshwar Cab with Driver"],
  ["Ertiga Crysta Pune to Mahabaleshwar", "Wedding Trip Pune to Mahabaleshwar Ertiga"],
  ["Group Travel Cab Ertiga Pune"]
],


"whychoose": [
  {
    "WhyChooseheading": "Reliable Ertiga on Rent from Pune to Mahabaleshwar",
    "WhyChoosedescription": "Prince Cabs provides dependable Ertiga rental services for travel from Pune to Mahabaleshwar, ideal for families, groups, and tourists looking to explore this beautiful hill station comfortably. Our service guarantees timely pickups, safe driving, and a smooth journey across scenic routes, making your trip memorable and hassle-free."
  },
  {
    "WhyChooseheading": "Spacious and Comfortable Ertiga for Hill Station Trips",
    "WhyChoosedescription": "Our Maruti Suzuki Ertiga offers ample space with seating for up to 6 passengers plus driver and generous luggage capacity, perfect for carrying your bags and picnic essentials. Equipped with air conditioning and comfortable interiors, the Ertiga ensures a pleasant and relaxing ride on winding roads leading to Mahabaleshwar."
  },
  {
    "WhyChooseheading": "Flexible Rental Packages for One-Way and Round Trips",
    "WhyChoosedescription": "Choose from customizable rental options including one-way trips, round trips, or multi-day rentals. Whether you want a day trip or an extended stay in Mahabaleshwar, Prince Cabs provides flexible booking plans tailored to your travel itinerary with clear, upfront pricing."
  },
  {
    "WhyChooseheading": "Experienced Drivers Familiar with Pune-Mahabaleshwar Route",
    "WhyChoosedescription": "Our professional drivers have in-depth knowledge of the Pune to Mahabaleshwar route, including the best scenic stops and safe driving practices on hill roads. They ensure timely breaks, smooth navigation, and a safe travel experience so you can enjoy the journey as much as the destination."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Our pricing for Pune to Mahabaleshwar Ertiga rentals covers fuel, tolls, driver allowances, and taxes with complete transparency. We provide detailed fare quotes before booking and accept various payment options such as UPI, credit/debit cards, net banking, and cash."
  },
  {
    "WhyChooseheading": "Sanitized, Well-Maintained, and Safe Vehicles",
    "WhyChoosedescription": "Each Ertiga is thoroughly cleaned and sanitized before every trip. Regular maintenance ensures mechanical reliability, and safety features like airbags and seat belts protect passengers throughout the journey. We prioritize your safety and comfort, especially on hill drives."
  },
  {
    "WhyChooseheading": "24/7 Customer Support for Seamless Travel Experience",
    "WhyChoosedescription": "Our dedicated customer care team is available round the clock to assist with bookings, itinerary adjustments, and any travel-related queries. From Pune to Mahabaleshwar and back, Prince Cabs ensures a hassle-free, well-coordinated travel experience."
  }
]





















    }

const faqData = [
    {
        question: 'Can I rent an Ertiga for a Pune to Mahabaleshwar trip with Prince Cabs?',
        answer: 'Yes, Prince Cabs offers comfortable and spacious Ertiga rentals for one-way and round trips between Pune and Mahabaleshwar.',
    },
    {
        question: 'Is the Ertiga suitable for the hilly terrain between Pune and Mahabaleshwar?',
        answer: 'Absolutely! The Ertiga is a reliable and comfortable vehicle, well-suited for the winding roads to Mahabaleshwar.',
    },
    {
        question: 'Are the Ertiga cabs sanitized and well-maintained?',
        answer: 'Yes, all Ertiga vehicles are regularly cleaned, sanitized, and serviced to ensure a safe and pleasant journey.',
    },
    {
        question: 'Does the Ertiga rental include a driver?',
        answer: 'Yes, every Ertiga rental from Pune to Mahabaleshwar includes a professional and courteous driver for a hassle-free trip.',
    },
    {
        question: 'What is the fare for renting an Ertiga from Pune to Mahabaleshwar?',
        answer: 'Fares depend on trip type (one-way or round trip), distance, and duration. Please contact Prince Cabs for a customized quote.',
    },
    {
        question: 'Can I book a round trip Ertiga rental for Pune to Mahabaleshwar?',
        answer: 'Yes, Prince Cabs offers flexible round-trip packages with Ertiga rentals between Pune and Mahabaleshwar.',
    },
    {
        question: 'How do I book an Ertiga on rent from Pune to Mahabaleshwar?',
        answer: 'You can easily book through our website or by calling our customer support team for quick assistance and confirmation.',
    },
];

const testimonials = [
    {
        name: "Mr. Sameer Joshi",
        position: "Nature Enthusiast",
        text: "Our Pune to Mahabaleshwar trip with Prince Cabs in an Ertiga was comfortable and enjoyable. The driver was very professional.",
        image: "/img/testimonial/testimonial-thumb-ertiga-pune-mahabaleshwar-1.png",
    },
    {
        name: "Ms. Pooja Kulkarni",
        position: "Family Traveler",
        text: "The Ertiga we rented for our Pune to Mahabaleshwar trip was spacious and clean. Highly recommend Prince Cabs for such trips.",
        image: "/img/testimonial/testimonial-thumb-ertiga-pune-mahabaleshwar-2.png",
    },
];
















































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9284304420",
            "+91 8308844163",


        ],
        email: "booking@princecab.com"
    };


    const Images = [
  { place: "/images/keyword/1.jpg",  text: "Innova Cab on Rent in Hadapsar Pune",            link: "innova-cab-on-rent-in-hadapsar-pune" },
  { place: "/images/keyword/2.jpg",  text: "Pune To Mahabaleshwar Innova Cab",                link: "pune-to-mahabaleshwar-innova-cab" },
  { place: "/images/keyword/3.jpg",  text: "Pune to Shirdi Innova Cab Booking",               link: "pune-to-shirdi-innova-cab-booking" },
  { place: "/images/keyword/4.jpg",  text: "Pune to Mumbai Airport Innova Cab",               link: "pune-to-mumbai-airport-innova-cab" },
  { place: "/images/keyword/5.jpg",  text: "Pune to Goa Innova Cab",                          link: "pune-to-goa-innova-cab" },
  { place: "/images/keyword/6.jpg",  text: "Pune to Ashtavinayak Innova Tour Package",        link: "pune-to-ashtavinayak-innova-tour-package" },
  { place: "/images/keyword/7.jpg",  text: "Sedan Cab Service in Pune",                       link: "sedan-cab-service-in-pune" },
  { place: "/images/keyword/8.jpg",  text: "Etios Cab for Outstation in Pune",                link: "etios-cab-for-outstation-in-pune" },
  { place: "/images/keyword/9.jpg",  text: "Toyota Etios Cab Booking in Pune",                link: "toyota-etios-cab-booking-in-pune" },
  { place: "/images/keyword/10.jpg", text: "Swift Dzire On Rent Pune",                        link: "swift-dzire-on-rent-pune" },
  { place: "/images/keyword/11.jpg", text: "Pune to Shirdi Swift Dzire Cab",                  link: "pune-to-shirdi-swift-dzire-cab" },
  { place: "/images/keyword/12.jpg", text: "Pune to Mahabaleshwar Swift Dzire Cabs",          link: "pune-to-mahabaleshwar-swift-dzire-cabs" },
  { place: "/images/keyword/13.jpg", text: "Pune to Mumbai Dzire Cab",                        link: "pune-to-mumbai-dzire-cab" },
  { place: "/images/keyword/14.jpg", text: "Pune to Gujarat Cab",                             link: "pune-to-gujarat-cab" },
  { place: "/images/keyword/15.jpg", text: "Pune to Rajasthan Cab",                           link: "pune-to-rajasthan-cab" },
  { place: "/images/keyword/16.jpg", text: "Pune to Indore Cab Booking",                      link: "pune-to-indore-cab-booking" },
  { place: "/images/keyword/17.jpg", text: "Pune to Vijayawada Cabs",                         link: "pune-to-vijayawada-cabs" },
  { place: "/images/keyword/18.jpg", text: "Pune to Bangalore Cab",                           link: "pune-to-bangalore-cab" },
  { place: "/images/keyword/19.jpg", text: "Pune to Hyderabad Cab",                           link: "pune-to-hyderabad-cab" },
  { place: "/images/keyword/20.jpg", text: "Pune to Belgaum Cab",                             link: "pune-to-belgaum-cab" },
  { place: "/images/keyword/21.jpg", text: "Pune to Mahabaleshwar Cab",                       link: "pune-to-mahabaleshwar-cab" },
  { place: "/images/keyword/22.jpg", text: "Pune to Panchgani Cab",                           link: "pune-to-panchgani-cab" },
  { place: "/images/keyword/23.jpg", text: "Pune to Goa Cab",                                 link: "pune-to-goa-cab" },
  { place: "/images/keyword/24.jpg", text: "Pune to Bhimashankar Cab",                        link: "pune-to-bhimashankar-cab" },
  { place: "/images/keyword/25.jpg", text: "Pune to Shirdi Cab",                              link: "pune-to-shirdi-cab" },
];




    const images = [
        { src: "/images/gallery/1.jpg", alt: "Image 1" },
        { src: "/images/gallery/5.jpg", alt: "Image 1" },
        { src: "/images/gallery/2.jpg", alt: "Image 1" },
        { src: "/images/gallery/3.jpg", alt: "Image 1" },
        { src: "/images/gallery/4.jpg", alt: "Image 1" },
        { src: "/images/gallery/6.jpg", alt: "Image 1" },

    ];



const productSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "Pune to Mahabaleshwar Ertiga On Rent",
  "description": "Affordable and comfortable 7 Seater Ertiga cab rental from Pune to Mahabaleshwar for family trips, round trips, wedding travel, and group tours with AC and driver.",
  "provider": {
    "@type": "LocalBusiness",
    "name": "Prince Cabs",
    "telephone": "+91-XXXXXXXXXX",
    "address": {
      "@type": "PostalAddress",
      "addressLocality": "Pune",
      "addressRegion": "Maharashtra",
      "addressCountry": "IN"
    }
  },
  "serviceType": [
    "Pune to Mahabaleshwar Ertiga Booking",
    "Ertiga 7 Seater Pune to Mahabaleshwar",
    "Ertiga for Family Trip to Mahabaleshwar",
    "Ertiga One Way Cab Pune to Mahabaleshwar",
    "Pune to Mahabaleshwar Round Trip Ertiga",
    "Pune to Mahabaleshwar Affordable Ertiga",
    "Pune to Mahabaleshwar AC Ertiga Cab",
    "Ertiga Outstation Cab Pune",
    "Pune to Mahabaleshwar SUV Ertiga",
    "Ertiga Tour Package Pune to Mahabaleshwar",
    "Comfortable Ertiga Cab Pune",
    "Pune to Mahabaleshwar Cab with Driver",
    "Ertiga Crysta Pune to Mahabaleshwar",
    "Wedding Trip Pune to Mahabaleshwar Ertiga",
    "Group Travel Cab Ertiga Pune"
  ],
  "areaServed": {
    "@type": "City",
    "name": "Pune"
  }
};






    return (
        <div>
<Helmet>
  <title>Pune to Mahabaleshwar Ertiga On Rent | 7 Seater Cab Booking</title>
  <meta
    name="description"
    content="Affordable and comfortable 7 Seater Ertiga cab rental from Pune to Mahabaleshwar for family trips, round trips, wedding travel, and group tours with AC and driver."
  />
  <meta
    name="keywords"
    content="Pune to Mahabaleshwar Ertiga Booking, Ertiga 7 Seater Pune to Mahabaleshwar, Ertiga for Family Trip to Mahabaleshwar, Ertiga One Way Cab Pune to Mahabaleshwar, Pune to Mahabaleshwar Round Trip Ertiga, Pune to Mahabaleshwar Affordable Ertiga, Pune to Mahabaleshwar AC Ertiga Cab, Ertiga Outstation Cab Pune, Pune to Mahabaleshwar SUV Ertiga, Ertiga Tour Package Pune to Mahabaleshwar, Comfortable Ertiga Cab Pune, Pune to Mahabaleshwar Cab with Driver, Ertiga Crysta Pune to Mahabaleshwar, Wedding Trip Pune to Mahabaleshwar Ertiga, Group Travel Cab Ertiga Pune"
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
            <section className="inner-banner-wrap">
                <div
                    className="inner-baner-container"
                    style={{ backgroundImage: 'url(/images/inner-banner.jpg)' }}
                >
                    <div className="container">
                        <div className="inner-banner-content">
                            <h1 className="inner-title">{cardData.keyword} </h1>
                        </div>
                    </div>
                </div>
                <div className="inner-shape"></div>
            </section>







            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/76.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#AF3125', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                             <div className="topPlaces">
  <p className="sectionLead">{cardData.top}</p>

  {cardData.topPlaces.map((place, index) => (
    <article key={index} className="placeCard" tabIndex="0">
      <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

      <div className="placeBody">
        <h4 className="placeTitle">{place.title}</h4>
        <p className="placeDesc">{place.description}</p>
      </div>

      <span className="placeArrow" aria-hidden>›</span>
    </article>
  ))}
</div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2 bg-foootr'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Vihaan Travels </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialSection testimonials={testimonials} />


 <ContactShowcase/>
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
  {Images.map((e, i) => {
    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

    return (
      <a
        key={e.link || i}
        href={href}
        className="routeItem"
        aria-label={e.text}
        {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
      >
        <div className="routeThumb">
          <img src={e.place} alt="" loading="lazy" />
        </div>

        <div className="routeMeta">
          <h6 className="routeTitle">{e.text}</h6>
          <span className="routeUnderline" />
        </div>

        <span className="routeArrow" aria-hidden>›</span>
      </a>
    );
  })}
</div>



                            {/* <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                        </div> */}
<div>
  <FleetHighway/>
</div>
                            <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919284304420" className="pc-call">+91 9284304420</a>
        <a href="tel:+918308844163" className="pc-call">+91 8308844163</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919284304420"
          target="_blank" rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp me-1"></i> WhatsApp
        </a>
        <a href="tel:+919284304420" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@princecab.com" className="pc-email">
        booking@princecab.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-house-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Prince Cabs</strong><br />
        Office No 106, 2nd Floor, Nilgiri Nest Co-op Housing Society,<br />
        Pimple Gurav, Pune, Pin - 411027
      </address>
    </section>
  </div>
</div>



                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetomahabaleshwarertiga ;